import React from 'react';

import { LANG_BG, LANG_EN, LanguageId } from '../i18n';

interface LanguageToggleProps {
    language: LanguageId;
    label: string;
    onLanguageChange: () => void;
}

const LanguageToggle: React.FC<LanguageToggleProps> = ({ language, label, onLanguageChange }) => {
    const isEnglish = language === LANG_EN;

    return (
        <button
            className={`language-toggle ${isEnglish ? 'is-en' : 'is-bg'}`}
            onClick={onLanguageChange}
            aria-label={label}
        >
            <span className="thumb" aria-hidden="true" />
            <span className={language === LANG_BG ? 'active' : ''}>BG</span>
            <span className={isEnglish ? 'active' : ''}>EN</span>
        </button>
    );
};

export default LanguageToggle;
